import * as React from "react";
import { Tabs, TabLink, TabContent } from "react-tabs-redux";
import { FaHome, FaSave } from "react-icons/fa";
import helpIcon from '../../assets/icons/help-square.svg'

import '../styles/MetamodelSelector.css';

import RequestHelper from "../utils/RequestHelper";
import Config from "../Config";
import MainModelTypes from "./MainModelTypes";
import MainObjectTypes from "./MainObjectTypes";
import MetamodelStore from "../resources/data/MetamodelStore";
import TemplateSave from "./modals/TemplateSave";
import Commons from "../utils/Commons";
import StateGlobal from "../StateGlobal";


export default class MetamodelSelector extends React.Component
{
    constructor(props)
    {
        super(props);
        this.state = {
            refresh: true
        };

        this.modelTypeListElem = React.createRef();
        this.objectTypeListElem = React.createRef();
        this.templateSave = React.createRef();

        Config.getConfig();
    }

    componentDidMount()
    {
        this.loadWholeMetamodel();
    }

    /**
     * Fetch whole metamodel using rest request
     */
    loadWholeMetamodel = () =>
    {
        const sReqUrl = Commons.createGatewayRequestUrl(
            {
                url: Config.anpRequestUrl.getMetamodel,
                dataType: "json"
            });
        RequestHelper.sendRequestCache(sReqUrl, "json").then(aData =>
        {
            if (Object.hasOwnProperty.call(aData, 'isErr') && aData.isErr)
            {
                console.error("Request error " + sReqUrl, aData);
                return;
            }

            if (Object.hasOwnProperty.call(aData, 'metamodel'))
            {
                try
                {
                    MetamodelStore.getInstance().setMetamodel(aData.metamodel); // setting data to MetamodelStore
                    this.modelTypeListElem.current.loadMetaModelTypes();
                    this.objectTypeListElem.current.loadMetaObjectTypes();
                    RequestHelper.getIcons('model');
                    RequestHelper.getIcons('object');
                    /**
                     * Timeout is here because each icon is loaded asynchronously. 100ms is totally enough to load cached icons.
                     * There is no problems when it would be not enough - not loaded icons will just not be shown.
                    */
                    setTimeout(() =>
                    {
                        this.modelTypeListElem.current.setActive();
                        this.objectTypeListElem.current.setActive();
                    }, 100);
                } catch (err)
                {
                    console.error(err);
                }
            }
        });
    }

    toggleModal = (aRef) =>
    {
        aRef.current.resetModal()
        aRef.current.toggleModal();
    }

    /**
    * Rendering the component (tabs Models/Objects)
    */
    render()
    {
        const { moveBackFn } = this.props;
        return (
            <Tabs>
                <div className="MetamodelSelector__topContainer">
                    <div className="MetamodelSelector__topBtnContainerLeft">
                        <button
                            className="wrcWidget__buttonIcon wrcWidget__buttonIcon--dark cursor-pointer"
                            onClick={() =>
                            {
                                moveBackFn(null);
                            }}
                        >
                            <FaHome style={{ fontSize: 16 }} />
                        </button>
                    </div>
                    <div className="MetamodelSelector__tabs">
                        <TabLink
                            className="MetamodelSelector__tabLink"
                            activeClassName="MetamodelSelector__tabLink MetamodelSelector__tabLink--active"
                            to="tab1"
                            onClick={()=>{
                                StateGlobal._isModelSelected = true;
                                StateGlobal._isObjectSelected = false;
                            }}
                        >
                            {Config.strings.tabs.create.models}
                        </TabLink>
                        <TabLink
                            className="MetamodelSelector__tabLink"
                            activeClassName="MetamodelSelector__tabLink MetamodelSelector__tabLink--active"
                            to="tab2"
                            onClick={()=>{
                                StateGlobal._isModelSelected = false;
                                StateGlobal._isObjectSelected = true;
                            }}
                        >
                            {Config.strings.tabs.create.objects}
                        </TabLink>
                    </div>
                    <div className="MetamodelSelector__topBtnContainerRight">
                        <TemplateSave
                            sTitle={Config.strings.modals.templateSave.sTitle}
                            sConfirmLabel={Config.strings.modals.templateSave.sConfirmLabel}
                            sRejectLabel={Config.strings.modals.templateSave.sRejectLabel}
                            ref={this.templateSave}
                        />
                        <div className="flex flex-row">
                            <button
                                className="wrcWidget__buttonIcon wrcWidget__buttonIcon--dark cursor-pointer"
                                onClick={this.toggleModal.bind(this, this.templateSave)}
                            >
                                <FaSave style={{ fontSize: 16 }} />
                            </button>
                            <button
                                className="wrcWidget__buttonIcon wrcWidget__buttonIcon--dark cursor-pointer"
                                onClick={()=>{
                                    window.location.href = Config.rcwAppDocumentation;
                                }}
                            >
                                <img src={helpIcon} height={18}/>
                            </button>
                        </div>
                    </div>
                </div>
                <div className="MetamodelSelector__tabsContent">
                    <TabContent for="tab1">
                        <MainModelTypes ref={this.modelTypeListElem}>
                        </MainModelTypes>
                    </TabContent>
                    <TabContent for="tab2">
                        <MainObjectTypes ref={this.objectTypeListElem}>
                        </MainObjectTypes>
                    </TabContent>
                </div>
            </Tabs>
        );
    }
}